// extracted by mini-css-extract-plugin
export default {"mount":"Mount_mount__qbaHD","active":"Mount_active__krwV-"};